export default __webpack_public_path__ + "static/spring_pic-734f5c9a07919cce3016a19b5bc4d9c6.png";